import { render, staticRenderFns } from "./select-screen-item.vue?vue&type=template&id=120f6df1"
import script from "./select-screen-item.vue?vue&type=script&lang=ts"
export * from "./select-screen-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports